class FpProductPurchaseSummary extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.section = this.closest('.shopify-section');
    this.listeners = new AbortController();
    this.isCbb = Boolean(this.section?.querySelector('[data-fp-cbb-config]'));
    this.section?.addEventListener('fp:cbb:state', event => this.renderState(event.detail), { signal: this.listeners.signal });
    if (this.isCbb) this.renderState(this.section.fpCbbState || { state: 'loading' });
    else {
      this.nativeVariant = {
        id: this.dataset.initialVariantId,
        price: Number(this.dataset.initialPrice), compare_at_price: Number(this.dataset.initialCompareAtPrice),
      };
      this.renderNative();
      this.section?.addEventListener('change', event => {
        if (event.target.matches('[name="quantity"]')) this.renderNative();
      }, { signal: this.listeners.signal });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
          if (String(event.data?.sectionId) !== String(this.dataset.sectionId)) return;
          if (event.data.variant) { this.nativeVariant = event.data.variant; this.renderNative(); }
        });
      }
    }
  }

  disconnectedCallback() { this.listeners?.abort(); this.unsubscribe?.(); this.initialized = false; }

  renderNative() {
    const quantity = Number(this.section?.querySelector('[name="quantity"]')?.value || 1);
    this.renderState({ state: 'ready', record: { ...this.nativeVariant, quantity } });
  }

  renderState({ state, record }) {
    const loading = state === 'loading';
    this.setAttribute('aria-busy', String(loading));
    this.toggleAttribute('data-fp-summary-pending', !record);
    this.toggle('[data-fp-summary-loading]', false);
    if (!record) {
      this.setText('[data-fp-summary-unit-price]', 'A confirmar');
      this.setText('[data-fp-summary-discount]', '');
      this.setText('[data-fp-summary-subtotal]', '');
      this.setText('[data-fp-summary-total]', 'A confirmar');
      this.setText('[data-fp-summary-discount-row] .fp-product-purchase-summary__label', this.dataset.pendingLabel || 'Aguardando confirmação');
      this.toggleClass('[data-fp-summary-unit-price]', 'fp-product-purchase-summary__value--compare', false);
      this.toggle('[data-fp-summary-discount-row]', this.dataset.showCompareAtDiscount === 'true');
      this.toggle('[data-fp-summary-subtotal-row]', false);
      this.toggle('[data-fp-summary-coupon-row]', false);
      return;
    }
    const price = Number(record.price) || 0;
    const compareAt = Number(record.compare_at_price) || 0;
    const quantity = Number.isInteger(record.quantity) && record.quantity > 0 ? record.quantity : 1;
    const showDiscount = this.dataset.showCompareAtDiscount === 'true' && compareAt > price;
    const total = price * quantity;
    const discount = Math.max(0, compareAt - price) * quantity;
    const showSubtotal = showDiscount && !(this.dataset.hideSubtotalWhenEqualsTotal === 'true' && price === total);
    this.setText('[data-fp-summary-unit-price]', this.formatMoney(showDiscount ? compareAt : price));
    this.setText('[data-fp-summary-subtotal]', this.formatMoney(price));
    this.setText('[data-fp-summary-total]', this.formatMoney(total));
    this.setText('[data-fp-summary-discount]', this.formatSignedMoney(discount));
    this.setText('[data-fp-summary-discount-row] .fp-product-purchase-summary__label', this.dataset.discountLabel || 'Desconto');
    this.toggleClass('[data-fp-summary-unit-price]', 'fp-product-purchase-summary__value--compare', showDiscount);
    this.toggle('[data-fp-summary-discount-row]', showDiscount);
    this.toggle('[data-fp-summary-subtotal-row]', showSubtotal);
    this.toggle('[data-fp-summary-coupon-row]', false);
    this.setText('[data-fp-summary-debug]', 'status=' + state + ' | variant=' + record.id);
  }

  setText(selector, value) {
    const target = this.querySelector(selector);
    if (target) target.textContent = value;
  }

  toggle(selector, isVisible) {
    this.querySelectorAll(selector).forEach((target) => {
      target.hidden = !isVisible;
    });
  }

  toggleClass(selector, className, shouldAdd) {
    this.querySelectorAll(selector).forEach((target) => {
      target.classList.toggle(className, shouldAdd);
    });
  }

  formatSignedMoney(cents) {
    if (!cents) return this.formatMoney(0);
    return `-${this.formatMoney(cents)}`;
  }

  formatMoney(cents) {
    return window.FPMoney.format(cents, this.dataset.moneyFormat);
  }

}
if (!customElements.get('fp-product-purchase-summary')) customElements.define('fp-product-purchase-summary', FpProductPurchaseSummary);
